export default {
  root: {
    minWidth: 200,
    borderRight: '1px solid rgba(0, 0, 0, 0.12)',
  },
};
